(function () {
  'use strict';

  function addRecipientsValidationFactory () {
    const factory = {};

    const structureOptions = {
      0: [ 'companyName', 'street', 'city', 'country', 'zipCode', 'countryCode'],
      1: [ 'firstName', 'lastName', 'street', 'city', 'country', 'zipCode', 'countryCode' ]
    };

    function validateStringFields (ctrl) {
      structureOptions[ Number(ctrl.recipientModel.type === 'private') ].forEach(function (key) {
        if (!(/\S/.test(ctrl.recipientModel[ key ]))) {
          ctrl.stringFields[ key ] = false;
        }
      });
    }

    function structureData (ctrl, fields) {
      const data = {};

      fields.forEach(function (key) {
        data[ key ] = ctrl.recipientModel[ key ];
      });

      // send data here
      // TODO: have an api call here for submission
      console.log(data);
      ctrl.showAddForm = false;
      ctrl.resetAll();
    }

    function checkValidity (ctrl) {
      function filterString (key) {
        return !ctrl.stringFields[ key ];
      }

      const stringInvalid = structureOptions[ Number(ctrl.recipientModel.type === 'private') ].filter(filterString);

      if (!stringInvalid.length) {
        factory.structureData(ctrl, structureOptions[ Number(ctrl.recipientModel.type === 'private') ]);
      }

    }

    function validate (ctrl) {
      ctrl.resetFields();

      factory.validateStringFields(ctrl);
      factory.checkValidity(ctrl);
    }


    factory.validate = validate;
    factory.validateStringFields = validateStringFields;
    factory.structureData = structureData;
    factory.checkValidity = checkValidity;

    return factory;
  }

  angular.module('web2print.recipients')
    .factory('addRecipientsValidationFactory', addRecipientsValidationFactory);
})();
